var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isOnPrem
      ? _c(
          "div",
          [
            _c("div", { staticClass: "va-title" }, [
              _vm._v(_vm._s(_vm.$t("licensesList.newTitle")))
            ]),
            _c("v-file-input", {
              ref: "licenseUploader",
              attrs: {
                accept: ".lic",
                label: "License file",
                variant: "outlined"
              },
              model: {
                value: _vm.fileLicense,
                callback: function($$v) {
                  _vm.fileLicense = $$v
                },
                expression: "fileLicense"
              }
            }),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c("va-button", {
                  staticClass: "mr-4",
                  attrs: {
                    color: "secondary",
                    type: "outline",
                    loading: _vm.$store.getters["onprem/loading"],
                    cta: _vm.$t("common.dismiss")
                  },
                  on: { click: _vm.onDismiss }
                }),
                _c("va-button", {
                  attrs: {
                    loading: _vm.$store.getters["onprem/loading"],
                    cta: _vm.$t("common.submit")
                  },
                  on: { click: _vm.onUpload }
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          [
            _vm.incompatibleKey
              ? _c(
                  "v-alert",
                  {
                    staticClass: "light mb-4",
                    attrs: {
                      type: "error",
                      dense: "",
                      "data-test": "license-not-compatible"
                    }
                  },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.incompatibleKey))]),
                    _vm._v(" - " + _vm._s(_vm.notCompatibleMessage) + " ")
                  ]
                )
              : _vm._e(),
            _c(
              "v-form",
              {
                ref: "newLicenseForm",
                attrs: { "lazy-validation": "", onSubmit: "return false;" },
                on: { submit: _vm.onSave },
                model: {
                  value: _vm.valid,
                  callback: function($$v) {
                    _vm.valid = $$v
                  },
                  expression: "valid"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex justify-space-between" },
                  [
                    _c("v-text-field", {
                      staticClass: "mr-4 mb-0",
                      attrs: {
                        rules: [_vm.required],
                        label: _vm.$t("common.key"),
                        outlined: "",
                        dense: ""
                      },
                      model: {
                        value: _vm.newLicense.licenseKey,
                        callback: function($$v) {
                          _vm.$set(_vm.newLicense, "licenseKey", $$v)
                        },
                        expression: "newLicense.licenseKey"
                      }
                    }),
                    _c("va-button", {
                      attrs: {
                        submit: "",
                        disabled: !_vm.valid,
                        loading: _vm.$store.getters["license/isLoading"],
                        cta: _vm.$t("roomWizard.next")
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }